
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M31.667 3.333H8.333c-.916 0-1.666-.75-1.666-1.666C6.667.75 7.417 0 8.333 0h23.334c.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666zM31.667 40H8.333c-.916 0-1.666-.75-1.666-1.666 0-.917.75-1.667 1.666-1.667h23.334c.916 0 1.666.75 1.666 1.667 0 .916-.75 1.666-1.666 1.666z"}}),_c('path',{attrs:{"d":"M30 13.333V1.667C30 .75 29.25 0 28.333 0H11.667C10.75 0 10 .75 10 1.667v11.666c0 .45.183.867.483 1.184L15.967 20l-5.484 5.483A1.65 1.65 0 0010 26.667v11.666c0 .917.75 1.667 1.667 1.667h16.666C29.25 40 30 39.25 30 38.333V26.667c0-.45-.183-.867-.483-1.184L24.033 20l5.484-5.483A1.65 1.65 0 0030 13.333zM24.517 27.15c.316.317.483.733.483 1.183v3.334c0 .916-.75 1.666-1.667 1.666h-6.666c-.917 0-1.667-.75-1.667-1.666v-3.334c0-.45.183-.866.483-1.183l3.334-3.333c.65-.65 1.7-.65 2.35 0L24.5 27.15h.017zM25 11.667c0 .45-.183.866-.483 1.183l-3.334 3.333c-.333.334-.75.484-1.183.484-.433 0-.85-.167-1.183-.484l-3.334-3.333A1.65 1.65 0 0115 11.667V8.333c0-.916.75-1.666 1.667-1.666h6.666c.917 0 1.667.75 1.667 1.666v3.334z"}})])
          )
        }
      }
    